
import { defineComponent, ref, reactive, toRefs, onMounted, watch, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import { init, ECharts, EChartsOption } from 'echarts'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Charts, Nodata },
  setup(props, context) {
    const color = globalsets.getColor()
    const pageData: any = reactive({
      list1: [],
      list2: [],
      data: [],
      data2: [],
      columns: [],
      columns2: [],
      visible: false,
      drawerdata: {},
      option: {},
      option2: {},
      optiongd_detail: {},
      spinning: true
    })
    watch(
      () => (props.pageSourceData || {}).CapitalStructureData,
      (val: any) => {
        if ((val || []).length) {
          pageData.list1 = [
            {
              title: '未流通股份',
              num: val[0].NonListedShares,
              ratio: val[0].NonListedSharesRate ? (val[0].NonListedSharesRate * 100).toFixed(2) + '%' : null,
              color: color[0]
            },
            {
              title: '流通受限股份',
              num: val[0].RestrictedShares,
              ratio: val[0].RestrictedSharesRate ? (val[0].RestrictedSharesRate * 100).toFixed(2) + '%' : null,
              color: color[1]
            },
            {
              title: '已流通股份',
              num: val[0].AlreadyShares,
              ratio: val[0].AlreadySharesRate ? (val[0].AlreadySharesRate * 100).toFixed(2) + '%' : null,
              color: color[2]
            },
            {
              title: '合计',
              num: val[0].TotalShares,
              ratio: val[0].TotalSharesRate ? (val[0].TotalSharesRate * 100).toFixed(2) + '%' : null
            }
          ]
          pageData.list2 = [
            {
              title: '已上市流通A股',
              num: val[0].NonRestrictedSharesA,
              ratio: val[0].NonRestrictedSharesARate ? (val[0].NonRestrictedSharesARate * 100).toFixed(2) + '%' : null,
              color: color[0]
            },
            {
              title: '已上市流通B股',
              num: val[0].NonRestrictedSharesB,
              ratio: val[0].NonRestrictedSharesBRate ? (val[0].NonRestrictedSharesBRate * 100).toFixed(2) + '%' : null,
              color: color[1]
            },
            {
              title: '境外上市流通股',
              num: val[0].Rpt_FFloatListed,
              ratio: val[0].Rpt_FFloatListedRate ? (val[0].Rpt_FFloatListedRate * 100).toFixed(2) + '%' : null,
              color: color[2]
            },
            {
              title: '其它已流通股份',
              num: val[0].OtherFloatShares,
              ratio: val[0].OtherFloatSharesRate ? (val[0].OtherFloatSharesRate * 100).toFixed(2) + '%' : null,
              color: color[3]
            },
            {
              title: '流通股份合计',
              num: val[0].TotalFloatShare,
              ratio: val[0].TotalFloatShareRate ? (val[0].TotalFloatShareRate * 100).toFixed(2) + '%' : null
            }
          ]
        }
        nextTick(() => {
          setdata1()
          setdata2()
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    function setdata1() {
      let _data1 = pageData.list1.map((item: any) => ({ name: item.title, value: item.num || 0, ratio: item.ratio }))
      _data1 = _data1.filter((item: any) => item.name !== '合计')
      pageData.option = {
        color: color,
        tooltip: {
          trigger: 'item',
          position: 'right',
          formatter: function(params: any) {
            const { data, color } = params
            // '{b}<br /> <i style="width: 10px;height: 10px;border-radius: 50%;"></i>比例： {d}%'
            return `<div class="optiontooltip"><p>${
              data.name
            }</p><div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.ratio ||
              '—'}</div>`
          }
        },
        legend: {
          show: false
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '65px',
            center: [80, ' 45%'],
            data: _data1,
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
    function setdata2() {
      let _data1 = pageData.list2.map((item: any) => ({ name: item.title, value: item.num || 0, ratio: item.ratio }))
      _data1 = _data1.filter((item: any) => item.name !== '流通股份合计')
      pageData.option2 = {
        color: color,
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '65%',
            center: [80, ' 45%'],
            data: _data1,
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            tooltip: {
              position: 'right',
              formatter: function(params: any) {
                const { data, color } = params
                // '{b}<br /> <i style="width: 10px;height: 10px;border-radius: 50%;"></i>比例： {d}%'
                return `<div class="optiontooltip"><p>${
                  data.name
                }</p><div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.ratio ||
                  '—'}</div>`
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
    return {
      ...toRefs(pageData),
      color
    }
  }
})
